(function (window) {
    "use strict";

    DSV.ui.anchor = {

        scrollTo: function(hash) {
            const elementId = hash.substring(1);
            const target = document.getElementById(elementId);
            const windowY = window.scrollY;
            const offsetY = Math.round(target.getBoundingClientRect().top + windowY);
            const headerHeight = document.querySelector('.header').offsetHeight;
            const scrollTargetPos = offsetY - headerHeight;
            const scrollLength = Math.abs(windowY - scrollTargetPos);
            const scrollDuration = scrollLength / 2000;

            TweenLite.to(window, scrollDuration, {scrollTo:scrollTargetPos, ease: Power3.easeOut});
        },

        handleAncherLinks: function(links){
            for (let i=0; i < links.length; i++) {
                links[i].addEventListener('click', (e) => {
                    e.preventDefault();
                    this.scrollTo(e.target.getAttribute('href'));
                });
            }
        },


        init: function() {

            let allAnchorLinks = Array.from(document.querySelectorAll( '[href^="#"]' ));

            let anchorLinks = allAnchorLinks.filter(function (e) {
                //do not include anchorlinks with only href "#"
                return e.getAttribute('href').length > 1;
            });


            if (anchorLinks.length > 0) { this.handleAncherLinks(anchorLinks) };

            if (location.hash) {
                setTimeout(this.scrollTo(location.hash), 300);
            }
        }
    };
})(window);